import { UserProvider } from '@auth0/nextjs-auth0';
import { createTheme, CssBaseline, NextUIProvider } from '@nextui-org/react';
import { ThemeProvider } from 'next-themes';

const lightTheme = createTheme({
	type: 'light',
	theme: {
		colors: {},
		space: {},
		fonts: {},
	},
});

const darkTheme = createTheme({
	type: 'dark',
	theme: {
		colors: {},
		space: {},
		fonts: {},
	},
});

function App({ Component, pageProps }) {
	return (
		<ThemeProvider
			defaultTheme="system"
			attribute="class"
			value={{
				light: lightTheme.className,
				dark: darkTheme.className,
			}}
      >
			<UserProvider>
				<NextUIProvider>
					<CssBaseline />
					<Component {...pageProps} />
				</NextUIProvider>
			</UserProvider>
		</ThemeProvider>
	);
}

export default App;
